export const getImpcsWithMrdsList = (state) => state.impc.impcsWithMrdsList;
export const getAllImpcList = (state) => state.impc.allImpcList;
